var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('h2',[_vm._v("Page not found.")]),_c('p',[_vm._v("We're sorry.  We were unable to find this page.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }